/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Contact_SupportInputs */

const en_common_contact_support = /** @type {(inputs: Common_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Support`)
};

const es_common_contact_support = /** @type {(inputs: Common_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactar soporte`)
};

/**
* | output |
* | --- |
* | "Contact Support" |
*
* @param {Common_Contact_SupportInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_contact_support = /** @type {((inputs?: Common_Contact_SupportInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Contact_SupportInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_contact_support(inputs)
	return en_common_contact_support(inputs)
});